import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
  useLayoutEffect,
} from 'react';
import {
  MenuIcon,
  EditUserIcon,
  EmailUserIcon,
  EmailUserDisabledIcon,
} from './ActionMenuSvg';
//import { useSelector } from 'react-redux';
//import MasterPermissions from '../../../api/MasterPermissions';
import './action-menu.scss';

export const ActionMenus = forwardRef(
  ({ enrollmentHandler, otherActionItems }, ref) => {
    const actionMenusItemsRef = useRef(null);
    const [showMenu, setShowMenu] = useState(false);
    //const { userData } = useSelector( state => state.user );
    //const showActionPanel = editOrDuplicateUser || (restPassword && status !== 'Pending Registration');

    const onMenuItemClickHandler = (e) => {
      e.stopPropagation();
      setShowMenu(false);
    };

    useEffect(() => {
      const onDocumentClickHandler = (e) => {
        if (showMenu && ref.current && !ref.current.contains(e.target)) {
          setShowMenu(false);
        }
      };

      document.addEventListener('mousedown', onDocumentClickHandler);

      return () => {
        //Cleanup the event listener
        document.removeEventListener('mousedown', onDocumentClickHandler);
      };
    }, [showMenu]);

    useLayoutEffect(() => {
      function handleResize() {
        if (ref && ref.current) {
          const top = ref.current.getBoundingClientRect().top;
          const height = ref.current.getBoundingClientRect().height;
          if (actionMenusItemsRef && actionMenusItemsRef.current) {
            actionMenusItemsRef.current.style.top = height + 'px';
          }
        }
      }

      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [ref, actionMenusItemsRef]);
    return (
      <>
        <div
          className="action-menu-container"
          ref={ref}
          onClick={() => {
            setShowMenu(!showMenu);
          }}
        >
          <div className="d-flex">
            <span>
              <MenuIcon />
            </span>{' '}
            <span>Quick Action</span>
          </div>
          <div
            className={`action-menu-item-container ${showMenu ? 'show' : ''}`}
            ref={actionMenusItemsRef}
          >
            <div
              onClick={(e) => {
                onMenuItemClickHandler(e);
                enrollmentHandler();
              }}
            >
              <span>
                <EditUserIcon />
              </span>{' '}
              Enrollment
            </div>
            {/*{editOrDuplicateUser ? (
              <div
                onClick={(e) => {
                  onMenuItemClickHandler(e);
                  enrollmentHandler();
                }}
              >
                <span>
                  <EditUserIcon />
                </span>{' '}
                Enrollment
              </div>
            ) : (
              <div className="other-status">
                <span>
                  <EditUserDisabledIcon />
                </span>{' '}
                Enrollment
              </div>
            )} */}
            {/*editOrDuplicateUser && <div onClick={(e) => {onMenuItemClickHandler(e); duplicateUserHandler();}}><span><DuplicateIcon /></span> Duplicate User</div> */}
            {/*{status !== 'Pending Registration' &&
            MasterPermissions.CheckPermission('Reset Password') ? (
              <div
                onClick={(e) => {
                  onMenuItemClickHandler(e);
                  resetPasswordHandler();
                }}
              >
                <span>
                  <UserLockIcon />
                </span>{' '}
                Reset Password
              </div>
            ) : (
              <div className="other-status">
                <span>
                  <UserLockDIsabledIcon />
                </span>{' '}
                Reset Password
              </div>
            )} */}
            {otherActionItems ? (
              <div
                onClick={(e) => {
                  onMenuItemClickHandler(e);
                }}
              >
                <span>
                  <EmailUserIcon />
                </span>{' '}
                Other Action Item
              </div>
            ) : (
              <div className="other-status">
                <span>
                  <EmailUserDisabledIcon />
                </span>{' '}
                Other Action Item
              </div>
            )}
          </div>
        </div>
        {/*} */}
      </>
    );
  },
);
